'use client'

import React, { useState, useEffect } from 'react';
import { IconWifiOff, IconWifiOn, IconX } from '@/components/ui/icons-v2'
import NotificationInitializer from '@/components/notifications/notifications-initializer'
import { useLogger } from '@/lib/hooks/useLogger';
const InternetConnectionStatus = () => {
  const [isOnline, setIsOnline] = useState(true);
  const [showNotification, setShowNotification] = useState(false);
  const [showInitializer, setShowInitializer] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);
  const logger = useLogger();
  useEffect(() => {
    const handleOnline = () => {
      if (wasOffline) {
        logger.info('Re-initializing notifications after wifi restored')
        setShowInitializer(true);
      }
      setIsOnline(true);
      setShowNotification(true);
      setWasOffline(false);
      setTimeout(() => setShowNotification(false), 5000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowNotification(true);
      setWasOffline(true);
    };

    setIsOnline(navigator.onLine);
    setWasOffline(!navigator.onLine);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  const handleDismiss = () => {
    setShowNotification(false);
    setShowInitializer(false);
  };

  if (!showNotification && !showInitializer) return null;

  return (
    <>
      {showNotification && (
        <div className="fixed bottom-10 right-8 max-w-[300px] w-full bg-white dark:bg-black rounded-lg shadow-lg py-4 px-4 z-50">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              {isOnline ? (
                <IconWifiOn className="size-7 text-green-500 ml-1" />
              ) : (
                <IconWifiOff className="size-7 text-red-500 ml-1" />
              )}
              <span className="text-sm ml-3 font-semibold">
                {isOnline
                  ? 'Internet Connection Restored'
                  : 'No Internet Connection'}
              </span>
            </div>
            <button
              onClick={handleDismiss}
              className="text-gray-500 hover:text-gray-700"
            >
              <IconX className="size-5" />
            </button>
          </div>
        </div>
      )}
      {showInitializer && <NotificationInitializer />}
    </>
  )
};

export default InternetConnectionStatus;
